import myData from '../_json/russian.json';
export default function Messages (){
    const allMessages = myData
    return allMessages
}